function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => model.modelViewerUI?.pause());
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

const serializeForm = form => {
  const obj = {};
  const formData = new FormData(form);
  for (const key of formData.keys()) {
    obj[key] = formData.get(key);
  }
  return JSON.stringify(obj);
};

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');
    const summaryElements = this.querySelectorAll('summary');
    this.addAccessibilityAttributes(summaryElements);
    this.focusOutTrigger = true;

    if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    if (this.focusOutTrigger) {
      this.addEventListener('focusout', this.onFocusOut.bind(this));
    }
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button:not(.dropdown-toggle)').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  addAccessibilityAttributes(summaryElements) {
    summaryElements.forEach(element => {
      element.setAttribute('role', 'button');
      element.setAttribute('aria-expanded', false);
      element.setAttribute('aria-controls', element.nextElementSibling.id);
    });
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute('open');

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));

      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
      });
    }
  }

  openMenuDrawer(summaryElement) {
    if (!this.mainDetailsToggle) return
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
      document.querySelector('header').classList.add('menu-opening-header');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event !== undefined) {
      this.mainDetailsToggle.classList.remove('menu-opening');
      document.querySelector('header').classList.remove('menu-opening-header');
      this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
        details.removeAttribute('open');
        details.classList.remove('menu-opening');
        document.querySelector('header').classList.remove('menu-opening-header');
      });
      this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
      document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
      removeTrapFocus(elementToFocus);
      this.closeAnimation(this.mainDetailsToggle);
    }
  }

  onFocusOut(event) {
    if (!this.focusOutTrigger) return
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove('menu-opening');
    removeTrapFocus();
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
    const openButtons = this.querySelectorAll('.header__icon--summary')
    const closeButtons = document.querySelectorAll('[data-menu-close]')
    this.headerDrawer = this.querySelector('.menu-drawer-container')
    openButtons.forEach(button => button.addEventListener('click', this.onSummaryClick.bind(this)))
    closeButtons.forEach(button => button.addEventListener('click', (e) => {
      this.closeMenuDrawer(e)
    }))
    const submenuOpenButton = this.querySelectorAll('[data-submenu-open]')
    const submenuCloseButton = this.querySelectorAll('[data-submenu-close]')
    submenuOpenButton.forEach(btn => btn.addEventListener('click', e => {
      e.preventDefault()
      this.openSubmenuDrawer(e.currentTarget)
    }))
    submenuCloseButton.forEach(btn => btn.addEventListener('click', e => {
      e.preventDefault()
      this.closeSubmenuDrawer(e.currentTarget)
    }))
    this.focusOutTrigger = false
  }

  openMenuDrawer(openButton) {
    this.header = this.header || document.getElementById('shopify-section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);

    setTimeout(() => {
      this.headerDrawer.classList.add('menu-opening');
      document.querySelector('header').classList.add('menu-opening-header');
    });

    openButton.setAttribute('aria-expanded', true);
    openButton.setAttribute('aria-label', 'Close Menu');
    trapFocus(this.headerDrawer, openButton);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  toggleDropdown(btn) {
    const wrapper = this.querySelector(`[data-dropdown="${btn.dataset.target}"]`)
    wrapper.classList.toggle('active')
    btn.setAttribute('aria-expanded', true);
    btn.setAttribute('aria-label', 'Close Menu');
    trapFocus(wrapper);
  }

  openSubmenuDrawer(btn) {
    const wrapper = this.querySelector(`[data-submenu="${btn.dataset.target}"]`)
    wrapper.classList.add('active')
    const elementToFocus = wrapper.querySelector('[data-submenu-close]')
    trapFocus(wrapper, elementToFocus)
  }

  closeSubmenuDrawer(btn) {
    const wrapper = this.querySelector(`[data-submenu="${btn.dataset.target}"]`)
    wrapper.classList.remove('active')
    removeTrapFocus()
  }

  closeAllSubmenuDrawer() {
    const drawers = this.querySelectorAll('[data-submenu]')
    drawers.forEach(drawer => drawer.classList.remove('active'))
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const isOpen = summaryElement.getAttribute('aria-expanded') === 'true';

    if (isOpen) event.preventDefault();
    isOpen ? this.closeMenuDrawer(summaryElement) : this.openMenuDrawer(summaryElement);
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('.menu-drawer-container');
    this.closeSubmenu(detailsElement);
    this.closeAllSubmenuDrawer()
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event !== undefined) {
      this.headerDrawer.classList.remove('menu-opening');
      document.querySelector('header').classList.remove('menu-opening-header');
      this.headerDrawer.querySelectorAll('.menu-drawer-container').forEach(details => {
        details.classList.remove('menu-opening');
        document.querySelector('header').classList.remove('menu-opening-header');
      });
      this.headerDrawer.querySelector('.header__icon--summary').setAttribute('aria-expanded', false);
      this.headerDrawer.querySelector('.header__icon--summary').setAttribute('aria-label', 'Open Menu');
      document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
      removeTrapFocus(elementToFocus);
      this.closeAnimation(this.headerDrawer);
      this.closeAllSubmenuDrawer()
    }
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this)
    );
    this.addEventListener('click', (event) => {
      if (event.target.nodeName === 'MODAL-DIALOG') this.hide();
    });
    this.addEventListener('keyup', () => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
  }

  show(opener) {
    this.openedBy = opener;
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    this.querySelector('.template-popup')?.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');
    button?.addEventListener('click', () => {
      document.querySelector(this.getAttribute('data-modal'))?.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="Deferred-Poster-"]')?.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent() {
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      window.pauseAllMedia();
      this.appendChild(content.querySelector('video, model-viewer, iframe')).focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('ul');
    this.sliderItems = this.querySelectorAll('li');
    this.pageCount = this.querySelector('.slider-counter--current');
    this.pageTotal = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    if (!this.sliderItems.length === 0) return;
    this.slidesPerPage = Math.floor(this.slider.clientWidth / this.sliderItems[0].clientWidth);
    this.totalPages = this.sliderItems.length - this.slidesPerPage + 1;
    this.update();
  }

  update() {
    if (!this.pageCount || !this.pageTotal) return;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItems[0].clientWidth) + 1;

    if (this.currentPage === 1) {
      this.prevButton.setAttribute('disabled', true);
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.currentPage === this.totalPages) {
      this.nextButton.setAttribute('disabled', true);
    } else {
      this.nextButton.removeAttribute('disabled');
    }

    this.pageCount.textContent = this.currentPage;
    this.pageTotal.textContent = this.totalPages;
  }

  onButtonClick(event) {
    event.preventDefault();
    const slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + this.sliderItems[0].clientWidth : this.slider.scrollLeft - this.sliderItems[0].clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    // this.updateOptions();
    // this.updateMasterId();
    this.buyItNowButton = document.querySelector('.product-form__button-buy-now a');
    this.addEventListener('change', this.onVariantChange);

    this.updateBuyItNowButton = this.updateBuyItNowButton.bind(this);
    this.onVariantChange();
    console.log('constructing')
    // this.updateBuyItNowButton();
  }

  onVariantChange() {
    console.log('onVariantChange', this)
    this.updateOptions();
    this.updateMasterId();
    this.updatePickupAvailability();
    if (!this.currentVariant) {
      this.setUnavailable();
      console.log('unavailable')
    } else {
      console.log('available')
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();

      this.updatePrice();
      this.updateBuyItNowButton();
    }
  }

  updateBuyItNowButton() {
    if (!this.buyItNowButton) return;
    const quantity = document.querySelector(".quantity__input").value;
    const staticId = this.buyItNowButton.getAttribute('data-variant-id');
    const id = Boolean(this?.currentVariant?.id) ? this.currentVariant.id : staticId;
    let formData = {
      items: [{
        id: Number(id),
        quantity: quantity,
      }]
    };
    if (this.currentVariant) {
      if (!this?.currentVariant?.available) {
        this.buyItNowButton.classList.add('disabled');
      } else {
        this.buyItNowButton.classList.remove('disabled');
      }
    }
    this.buyItNowButton.addEventListener('click', (event) => {
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      }).then(response => {
        window.addInProgress = true;
        window.location.href = '/checkout';
        return false;
      }).catch((error) => {
        window.addInProgress = false;
        console.error('Error:', error);
      });
    });
  }

  updatePrice() {

    let afterpay = document.querySelector('afterpay-placement');
    const price = this.currentVariant.price;
    const priceRegular = `$${(this.currentVariant.price / 100 / 4).toFixed(2)}`;
    let afterpayPrice = afterpay?.shadowRoot?.querySelector('.afterpay-main-text strong');
    let recharge = document.querySelector('subscription-selects');
    let subsave = recharge?.querySelector('.rc_widget__option__input--subsave');

    document.querySelector('.price-container').dataset.price = price;

    if (afterpayPrice) {
      if (subsave?.checked && afterpayPrice) {
        afterpayPrice.innerHTML = `$${((this.currentVariant.price / 100 / 4) * 0.95).toFixed(2)}`;
      } else {
        afterpayPrice.textContent = priceRegular;
      }
    }

    if (this.currentVariant.compare_at_price) {

      const priceInputs = document.querySelectorAll('.product__info-wrapper .price__sale .price-item--regular');
      const salePriceInputs = document.querySelectorAll('.product__info-wrapper .price__sale .price-item--sale');
      salePriceInputs.forEach(input => {
        input.innerHTML = `$${this.currentVariant.price / 100}`;
      });
      priceInputs.forEach(input => {
        input.innerHTML = `$${this.currentVariant.compare_at_price / 100}`;
      });
    } else {
      const priceInputs = document.querySelectorAll('.product__info-wrapper .price__regular .price-item--regular');
      priceInputs.forEach(input => {
        input.innerHTML = `$${this.currentVariant.price / 100}`;
      });
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {

    if (!this.currentVariant || !this.currentVariant?.featured_media) return;
    const newMedia = document.querySelector(
      `[data-media-id="${this.currentVariant.featured_media.id}"]`
    );
    if (!newMedia) return;
    const parent = newMedia.parentElement;
    parent.prepend(newMedia);
    window.setTimeout(() => { parent.scroll(0, 0) });


  }

  updateURL() {
    if (!this.currentVariant) return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant?.title?.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '')}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant?.available) {
      if (pickUpAvailability.fetchAvailability) {
        pickUpAvailability.fetchAvailability(this.currentVariant.id);
      }
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  renderProductInfo() {
    console.log('this', this)
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {

        const parser = new DOMParser();
        const doc3 = parser.parseFromString(responseText, "text/html")

        if (doc3.body.querySelector('.shopify-section.product-section-main .buy-button-area-wrap')) {
          // document.querySelector('.shopify-section.product-section-main .buy-button-area-wrap').innerHTML=doc3.body.querySelector('.shopify-section.product-section-main .buy-button-area-wrap').innerHTML;
          const doc3buyButtonArea = doc3.body.querySelector('.shopify-section.product-section-main .buy-button-area');

          document.querySelector('.shopify-section.product-section-main .buy-button-area-wrap .product-info-area').innerHTML = doc3.body.querySelector('.shopify-section.product-section-main .buy-button-area-wrap .product-info-area').innerHTML;
          document.querySelector('.shopify-section.product-section-main .buy-button-area-wrap .buy-button-area').innerHTML = doc3buyButtonArea.innerHTML;
          document.querySelector('.shopify-section.product-section-main .buy-button-area-wrap .product-info-area').setAttribute("data-variantid", this.currentVariant.id);
          document.getElementById(`price-${this.dataset.section}`)?.classList.remove('visibility-hidden');
        }
        const buttons = document.getElementsByTagName("label");

        var StickyImg = document.querySelector(".product__media-main-slider .swiper-slide-active img")
        console.log('renderProductInfo', StickyImg)
        StickyImg.classList.add("product-info_sticky");
        document.querySelector(".sticky-image_div").innerHTML = StickyImg.outerHTML;

        const input = document.querySelector('.rc_widget__option.rc_widget__option--onetime input')
        const planSelect = document.querySelector(".rc-selling-plans.rc_widget__option__plans")
        if (input) {
          input.checked = "checked"
          planSelect.style.display = 'none'
        }

      });
  }


  toggleAddButton(disable = true, text, modifyClass = true) {
    const addButton = document.getElementById(`product-form-${this.dataset.section}`)?.querySelector('[name="add"]');

    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', true);
      if (text) addButton.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButton.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const addButton = document.getElementById(`product-form-${this.dataset.section}`)?.querySelector('[name="add"]');
    if (!addButton) return;
    addButton.textContent = window.variantStrings.unavailable;
    document.getElementById(`price-${this.dataset.section}`)?.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }

}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });


  }
}

customElements.define('variant-radios', VariantRadios);

class SubscriptionSelects extends HTMLElement {
  constructor() {
    super();
  }
}

customElements.define('subscription-selects', SubscriptionSelects);

class WCProductCard extends HTMLElement {
  constructor() {
    super();
    this.linksElements = null;
    this.productJSON = null;
  }

  connectedCallback() {
    this.linksElements = Array.from(this.querySelectorAll("a")).filter(
      (link) => {
        const href = link.getAttribute("href");
        return href?.includes("/products/");
      }
    );
    if (!this.linksElements.length) {
      return;
    }

    this.productJSON = JSON.parse(
      this.querySelector("[data-product-json]")?.textContent ?? "{}"
    );
    if (!this.productJSON) {
      return;
    }

    this.linksElements.forEach((link) => {
      link.addEventListener("click", this.trackSelectItem);
    });
  }

  disconnectedCallback() {
    if (!this.linksElements.length || !this.productJSON) {
      return;
    }

    this.linksElements.forEach((link) => {
      link.removeEventListener("click", this.trackSelectItem);
    });
  }

  trackSelectItem = () => {
    window.trackEvents.selectItem({ product: this.productJSON });
  };
}

customElements.define("wc-product-card", WCProductCard);
